"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGrade = exports.submitInstructorGrade = exports.getGrades = exports.submitGrade = void 0;
const api_1 = __importDefault(require("@aws-amplify/api"));
const rl_shared_1 = require("@asu-etx/rl-shared");
const hashUtils_1 = require("../utils/hashUtils");
const buildScore = (params) => {
    const score = {};
    rl_shared_1.logger.debug(`params used to build score: ${params}`);
    score.scoreGiven = params.scoreGiven || params.scoreGiven == 0 || params.scoreGiven == 0.0 ? params.scoreGiven :
        params.grade || params.grade == 0 ? params.grade : params.resultScore;
    if (params.timestamp)
        score.timestamp = params.timestamp;
    score.comment = params.comment;
    if (params.activityProgress)
        score.activityProgress = params.activiyProgress;
    score.gradingProgress = params.progress ? params.progress : params.gradingProgress;
    if (params.studentId || params.userId)
        score.userId = params.studentId ? params.studentId : params.userId;
    if (params.scoreMaximum || params.resultMaximum)
        score.scoreMaximum = params.scoreMaximum ? params.scoreMaximum : params.resultMaximum;
    score.activityProgress = params.activityProgress ? params.activityProgress : determineProgress(score.gradingProgress);
    rl_shared_1.logger.debug(`final score: ${score}`);
    return new rl_shared_1.SubmitGradeParams(score);
};
const determineProgress = (gradingProgress) => {
    let activityProgress = gradingProgress == "NotReady" ? "InProgress" : "Completed";
    return activityProgress;
};
const submitGrade = async (aws_exports, params) => {
    const grades = buildScore(params);
    api_1.default.configure(aws_exports);
    const data = {
        headers: {
            'Content-Type': 'application/json'
        }, body: {
            params: grades,
            hash: hashUtils_1.getHash()
        }
    };
    rl_shared_1.logger.debug(`submitGrade results: ${data}`);
    const results = await api_1.default.post(rl_shared_1.LTI_API_NAME, rl_shared_1.PUT_STUDENT_GRADE, data);
    rl_shared_1.logger.debug(`submitGrade results: ${results}`);
    return results;
};
exports.submitGrade = submitGrade;
const submitInstructorGrade = async (aws_exports, params) => {
    return submitGrade(aws_exports, params);
};
exports.submitInstructorGrade = submitInstructorGrade;
const getGrades = async (aws_exports, assignmentId) => {
    api_1.default.configure(aws_exports);
    const grades = await api_1.default.get(rl_shared_1.LTI_API_NAME, rl_shared_1.GET_GRADES, {
        queryStringParameters: {
            resourceId: assignmentId,
            hash: hashUtils_1.getHash()
        }
    });
    return grades;
};
exports.getGrades = getGrades;
const getGrade = async (aws_exports, assignmentId, userId) => {
    api_1.default.configure(aws_exports);
    const grades = await api_1.default.get(rl_shared_1.LTI_API_NAME, rl_shared_1.GET_GRADES, {
        queryStringParameters: {
            resourceId: assignmentId,
            userId: userId,
            hash: hashUtils_1.getHash()
        }
    });
    return grades;
};
exports.getGrade = getGrade;
